import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 7C14.5523 7 15 7.44772 15 8V14C15 14.5523 14.5523 15 14 15H6C5.44772 15 5 14.5523 5 14V8C5 7.44772 5.44772 7 6 7H14ZM10 9C9.44772 9 9 9.44772 9 10C9 10.3698 9.20157 10.6912 9.5 10.8643V13H10.5V10.8643C10.7984 10.6912 11 10.3698 11 10C11 9.44772 10.5523 9 10 9Z"
      fill="#181818"
    />
    <rect
      x={7.75}
      y={3.75}
      width={4.5}
      height={10.5}
      rx={2.25}
      stroke="#181818"
      strokeWidth={1.5}
    />
  </svg>
);
export default SVGComponent;
